import { cn } from "@/lib/utils";

/** The scoreboard bulb. Appears only when something is happening now. */
export function LiveDot({
	className,
	still,
}: {
	className?: string;
	still?: boolean;
}) {
	return (
		<span
			aria-hidden
			className={cn(
				"inline-block size-2 shrink-0 rounded-full bg-signal",
				!still && "animate-pulse-dot",
				className,
			)}
		/>
	);
}
